export default "__VITE_ASSET__CmHW8TSX__"